/* LeatherDaddy homepage sections: reveal on scroll + lookbook chapters (desktop). */
(function () {
  if (window.__ldInit) return;
  window.__ldInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var io = null;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.ld-js-reveal:not(.ld-is-in)');
    if (design || reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ld-is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ld-is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  function lookbook(root) {
    var pins = (root || document).querySelectorAll('.ld-lookbook__pin');
    pins.forEach(function (pin) {
      if (pin.__ld) return;
      pin.__ld = true;
      var nums = pin.querySelectorAll('.ld-lookbook__num');
      var imgs = pin.querySelectorAll('.ld-lookbook__img');
      var chs = pin.querySelectorAll('.ld-lookbook__ch');
      var bar = pin.querySelector('.ld-lookbook__progress span');
      var total = Math.max(1, chs.length);
      function set(i) {
        [nums, imgs, chs].forEach(function (list) {
          list.forEach(function (n, j) { n.classList.toggle('ld-is-active', j === i); });
        });
      }
      function update() {
        if (!window.matchMedia('(min-width: 901px)').matches || reduce) return;
        var r = pin.getBoundingClientRect();
        var span = pin.offsetHeight - window.innerHeight;
        var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
        set(Math.min(total - 1, Math.floor(p * total)));
        if (bar) bar.style.width = (p * 100).toFixed(2) + '%';
      }
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function heroScroll() {
    var el = document.querySelector('.ld-hero__scroll');
    if (!el || el.__ld) return;
    el.__ld = true;
    window.addEventListener('scroll', function () {
      el.style.opacity = Math.max(0, 1 - window.scrollY / 300).toFixed(2);
    }, { passive: true });
  }

  function heroFit() {
    var h = document.querySelector('.ld-hero');
    if (!h) return;
    var top = h.getBoundingClientRect().top + window.scrollY;
    h.style.setProperty('--ld-hero-offset', Math.max(0, Math.round(top)) + 'px');
  }

  function boot(root) { heroFit(); reveal(root); lookbook(root); heroScroll(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  window.addEventListener('resize', heroFit);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
